const VALIDATION_MESSAGES = {
  "preTestPrimaryConditionsYesOrNo_1": "Please select just one option: yes or no.",
  "preTestPrimaryConditionsYesOrNo_2": "Please select just one option: yes or no.",
  "preTestPrimaryConditionsYesOrNo_3": "Please select just one option: yes or no.",
  "postTestPrimaryConditionsYesOrNo_1": "Please select just one option: yes, no, or NA.",
  "postTestPrimaryConditionsYesOrNo_2": "Please select just one option: yes, no, or NA.",
  "postTestPrimaryConditionsYesOrNo_3": "Please select just one option: yes, no, or NA.",
  "preTestCOTest_pickOne1": "Please select only one checkbox for the Flue Gas CO Test (clothes dryer, pre-test open door)",
  "preTestCOTest_pickOne2": "Please select only one checkbox for the Flue Gas CO Test (clothes dryer, pre-test closed door)",
  "postTestCOTest_pickOne1": "Please select only one checkbox for the Flue Gas CO Test (clothes dryer, post-test open door)",
  "postTestCOTest_pickOne2": "Please select only one checkbox for the Flue Gas CO Test (clothes dryer, post-test closed door)",
  "preTestGasLogPrimaryConditionsYesOrNo_1": "Please select just one option: yes or no (pre-test, primary, 1)",
  "preTestGasLogPrimaryConditionsYesOrNo_2": "Please select just one option: yes or no (pre-test, primary, 2)",
  "preTestGasLogPrimaryConditionsYesOrNo_3": "Please select just one option: yes or no (pre-test, primary, 3)",
  "preTestGasLogPrimaryConditionsYesOrNo_4": "Please select just one option: yes or no (pre-test, primary, 4)",
  "preTestGasLogPrimaryConditionsYesOrNo_5": "Please select just one option: yes or no (pre-test, primary, 5)",
  "preTestGasLogSecondaryConditionsYesOrNo_1": "Please select just one option: yes or no (pre-test, secondary, 1)",
  "preTestGasLogSecondaryConditionsYesOrNo_2": "Please select just one option: yes or no (pre-test, secondary, 2)",
  "preTestGasLogSecondaryConditionsYesOrNo_3": "Please select just one option: yes or no (pre-test, secondary, 3)",
  "preTestGasLogSecondaryConditionsYesOrNo_4": "Please select just one option: yes or no (pre-test, secondary, 4)",
  "preTestGasLogSecondaryConditionsYesOrNo_5": "Please select just one option: yes or no (pre-test, secondary, 5)",
  "postTestGasLogPrimaryConditionsYesOrNo_1": "Please select just one option: yes or no (post-test, primary, 1)",
  "postTestGasLogPrimaryConditionsYesOrNo_3": "Please select just one option: yes or no (post-test, primary, 3)",
  "postTestGasLogPrimaryConditionsYesOrNo_4": "Please select just one option: yes or no (post-test, primary, 4)",
  "postTestGasLogPrimaryConditionsYesOrNo_5": "Please select just one option: yes or no (post-test, primary, 5)",
  "postTestGasLogSecondaryConditionsYesOrNo_1": "Please select just one option: yes or no (post-test, secondary, 1)",
  "postTestGasLogSecondaryConditionsYesOrNo_3": "Please select just one option: yes or no (post-test, secondary, 3)",
  "postTestGasLogSecondaryConditionsYesOrNo_4": "Please select just one option: yes or no (post-test, secondary, 4)",
  "postTestGasLogSecondaryConditionsYesOrNo_5": "Please select just one option: yes or no (post-test, secondary, 5)",
  "preTestGasLog_pickOne1": "Please select only one checkbox for the Flue Gas CO Test (gas log, pre-test open door)",
  "preTestGasLog_pickOne2": "Please select only one checkbox for the Flue Gas CO Test (gas log, pre-test closed door)",
  "postTestGasLog_pickOne1": "Please select only one checkbox for the Flue Gas CO Test (gas log, post-test open door)",
  "postTestGasLog_pickOne2": "Please select only one checkbox for the Flue Gas CO Test (gas log, post-test closed door)",
  "preTestGasLogVisualDraft_pickOne1": "Please select only one checkbox for the Flue Gas CO Test (gas log, pre-test open door, visual draft)",
  "postTestGasLogVisualDraft_pickOne1": "Please select only one checkbox for the Flue Gas CO Test (gas log, post-test open door, visual draft)",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "dryerPreTestConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["dryerPreTestConditions1_yes", "dryerPreTestConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestPrimaryConditionsYesOrNo_1'];
      },
    }),
    "dryerPreTestConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["dryerPreTestConditions2_yes", "dryerPreTestConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestPrimaryConditionsYesOrNo_2'];
      },
    }),
    "dryerPreTestConditionsOther_yes": () => ({
      validate: () => {
        const yesOrNo = ["dryerPreTestConditionsOther_yes", "dryerPreTestConditionsOther_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestPrimaryConditionsYesOrNo_3'];
      },
    }),
    "dryerPostTestConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["dryerPostTestConditions1_yes", "dryerPostTestConditions1_no", "dryerPostTestConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimaryConditionsYesOrNo_1'];
      },
    }),
    "dryerPostTestConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["dryerPostTestConditions2_yes", "dryerPostTestConditions2_no", "dryerPostTestConditions2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimaryConditionsYesOrNo_2'];
      },
    }),
    "dryerPostTestConditionsOther_yes": () => ({
      validate: () => {
        const yesOrNo = ["dryerPostTestConditionsOther_yes", "dryerPostTestConditionsOther_no", "dryerPostTestConditionsOther_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimaryConditionsYesOrNo_3'];
      },
    }),
    "dryerPreTestOpenDoor_nf": () => ({
      validate: () => {
        const options = ["dryerPreTestOpenDoor_nf", "dryerPreTestOpenDoor_hazard", "dryerPreTestOpenDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestCOTest_pickOne1'];
      },
    }),
    "dryerPreTestClosedDoor_nf": () => ({
      validate: () => {
        const options = ["dryerPreTestClosedDoor_nf", "dryerPreTestClosedDoor_hazard", "dryerPreTestClosedDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestCOTest_pickOne2'];
      },
    }),
    "dryerPostTestOpenDoor_nf": () => ({
      validate: () => {
        const options = ["dryerPostTestOpenDoor_nf", "dryerPostTestOpenDoor_hazard", "dryerPostTestOpenDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestCOTest_pickOne1'];
      },
    }),
    "dryerPostTestClosedDoor_nf": () => ({
      validate: () => {
        const options = ["dryerPostTestClosedDoor_nf", "dryerPostTestClosedDoor_hazard", "dryerPostTestClosedDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestCOTest_pickOne2'];
      },
    }),
    "gasLogPreTestPrimaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestPrimaryConditions1_yes", "gasLogPreTestPrimaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogPrimaryConditionsYesOrNo_1'];
      },
    }),
    "gasLogPreTestPrimaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestPrimaryConditions2_yes", "gasLogPreTestPrimaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogPrimaryConditionsYesOrNo_2'];
      },
    }),
    "gasLogPreTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestPrimaryConditions3_yes", "gasLogPreTestPrimaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogPrimaryConditionsYesOrNo_3'];
      },
    }),
    "gasLogPreTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestPrimaryConditions4_yes", "gasLogPreTestPrimaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogPrimaryConditionsYesOrNo_4'];
      },
    }),
    "gasLogPreTestPrimaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestPrimaryConditions5_yes", "gasLogPreTestPrimaryConditions5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogPrimaryConditionsYesOrNo_5'];
      },
    }),
    "gasLogPreTestSecondaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestSecondaryConditions1_yes", "gasLogPreTestSecondaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogSecondaryConditionsYesOrNo_1'];
      },
    }),
    "gasLogPreTestSecondaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestSecondaryConditions2_yes", "gasLogPreTestSecondaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogSecondaryConditionsYesOrNo_2'];
      },
    }),
    "gasLogPreTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestSecondaryConditions3_yes", "gasLogPreTestSecondaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogSecondaryConditionsYesOrNo_3'];
      },
    }),
    "gasLogPreTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestSecondaryConditions4_yes", "gasLogPreTestSecondaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogSecondaryConditionsYesOrNo_4'];
      },
    }),
    "gasLogPreTestSecondaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPreTestSecondaryConditions5_yes", "gasLogPreTestSecondaryConditions5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogSecondaryConditionsYesOrNo_5'];
      },
    }),
    "gasLogPostTestPrimaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestPrimaryConditions1_yes", "gasLogPostTestPrimaryConditions1_no", "gasLogPostTestPrimaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogPrimaryConditionsYesOrNo_1'];
      },
    }),
    "gasLogPostTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestPrimaryConditions3_yes", "gasLogPostTestPrimaryConditions3_no", "gasLogPostTestPrimaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogPrimaryConditionsYesOrNo_3'];
      },
    }),
    "gasLogPostTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestPrimaryConditions4_yes", "gasLogPostTestPrimaryConditions4_no", "gasLogPostTestPrimaryConditions4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogPrimaryConditionsYesOrNo_4'];
      },
    }),
    "gasLogPostTestPrimaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestPrimaryConditions5_yes", "gasLogPostTestPrimaryConditions5_no", "gasLogPostTestPrimaryConditions5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogPrimaryConditionsYesOrNo_5'];
      },
    }),
    "gasLogPostTestSecondaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestSecondaryConditions1_yes", "gasLogPostTestSecondaryConditions1_no", "gasLogPostTestSecondaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogSecondaryConditionsYesOrNo_1'];
      },
    }),
    "gasLogPostTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestSecondaryConditions3_yes", "gasLogPostTestSecondaryConditions3_no", "gasLogPostTestSecondaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogSecondaryConditionsYesOrNo_3'];
      },
    }),
    "gasLogPostTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestSecondaryConditions4_yes", "gasLogPostTestSecondaryConditions4_no", "gasLogPostTestSecondaryConditions4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogSecondaryConditionsYesOrNo_4'];
      },
    }),
    "gasLogPostTestSecondaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasLogPostTestSecondaryConditions5_yes", "gasLogPostTestSecondaryConditions5_no", "gasLogPostTestSecondaryConditions5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogSecondaryConditionsYesOrNo_5'];
      },
    }),
    "gasLogPreTestOpenDoor_nf": () => ({
      validate: () => {
        const options = ["gasLogPreTestOpenDoor_nf", "gasLogPreTestOpenDoor_hazard", "gasLogPreTestOpenDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLog_pickOne1'];
      },
    }),
    "gasLogPreTestClosedDoor_nf": () => ({
      validate: () => {
        const options = ["gasLogPreTestClosedDoor_nf", "gasLogPreTestClosedDoor_hazard", "gasLogPreTestClosedDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLog_pickOne2'];
      },
    }),
    "gasLogPostTestOpenDoor_nf": () => ({
      validate: () => {
        const options = ["gasLogPostTestOpenDoor_nf", "gasLogPostTestOpenDoor_hazard", "gasLogPostTestOpenDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLog_pickOne1'];
      },
    }),
    "gasLogPostTestClosedDoor_nf": () => ({
      validate: () => {
        const options = ["gasLogPostTestClosedDoor_nf", "gasLogPostTestClosedDoor_hazard", "gasLogPostTestClosedDoor_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLog_pickOne2'];
      },
    }),
    "gasLogPreTestVisualDraft_pass": () => ({
      validate: () => {
        const options = ["gasLogPreTestVisualDraft_pass", "gasLogPreTestVisualDraft_fail", "gasLogPreTestVisualDraft_hazard", "gasLogPreTestVisualDraft_nf", "gasLogPreTestVisualDraft_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestGasLogVisualDraft_pickOne1'];
      },
    }),
    "gasLogPostTestVisualDraft_pass": () => ({
      validate: () => {
        const options = ["gasLogPostTestVisualDraft_pass", "gasLogPostTestVisualDraft_fail", "gasLogPostTestVisualDraft_hazard", "gasLogPostTestVisualDraft_nf", "gasLogPostTestVisualDraft_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestGasLogVisualDraft_pickOne1'];
      },
    }),
  };
};

export default useValidation;